import * as yup from 'yup';

export type CreateMcpTokenFormValues = {
  name: string;
};

export const createMcpTokenSchema = yup
  .object({
    name: yup.string().trim().label('Name').required().max(255)
  })
  .required();
